import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { createWorkStatus, CreateWorkStatusPayload, CreateWorkStatusResponse } from '../api/createWorkStatus';
import { ApiError } from 'types/apiError';
import { QUERY_KEYS } from 'service/querykeys';

export const useCreateWorkStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CreateWorkStatusResponse, ApiError, CreateWorkStatusPayload>({
    mutationFn: createWorkStatus,
    onSuccess: (_, variables) => {
      // Use the centralized key — this MUST match useProjectDefaultQuery's queryKey
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.PROJECT_DEFAULTS(variables.projectUuid),
      });
      toast.success('Column added successfully');
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to add column');
    },
  });
};
